import React, { useState, useEffect } from 'react';
import './EditorStyles.css';
import ServiceModal from './ServiceModal';
import ServiceDetailsModal from './ServiceDetailsModal';

const ServicesEditor = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [detailsService, setDetailsService] = useState(null);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/services`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setServices(data.data);
      }
    } catch (error) {
      console.error('Error loading services:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingService(null);
    setShowModal(true);
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setShowModal(true);
  };

  const handleSave = async (formData) => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const url = editingService
        ? `${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/services/${editingService.id}`
        : `${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/services`;
      
      const method = editingService ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (data.success) {
        setMessage(editingService ? 'تم تحديث الخدمة بنجاح!' : 'تم إضافة الخدمة بنجاح!');
        setShowModal(false);
        setEditingService(null);
        loadServices();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      console.error('Save error:', error);
      setMessage('خطأ في الاتصال');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف هذه الخدمة؟')) return;

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/services/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حذف الخدمة بنجاح!');
        loadServices();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      console.error('Delete error:', error);
      setMessage('خطأ في الاتصال');
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>إدارة الخدمات</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
        <button className="editor-btn-add" onClick={handleAdd}>
          + إضافة خدمة جديدة
        </button>
      </div>

      <div className="editor-items-list">
        {services.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#666' }}>لا توجد خدمات</p>
        ) : (
          services.map((service) => (
            <div key={service.id} className="editor-item-card">
              <div className="editor-item-content">
                <h4>{service.title_ar} / {service.title_en}</h4>
                <p>المعرف: {service.id} | الترتيب: {service.display_order}</p>
                {service.description_ar && (
                  <p><strong>عربي:</strong> {service.description_ar.substring(0, 100)}...</p>
                )}
                {service.description_en && (
                  <p><strong>إنجليزي:</strong> {service.description_en.substring(0, 100)}...</p>
                )}
                {service.image_url && (
                  <img 
                    src={service.image_url && (service.image_url.startsWith('http') ? service.image_url : `${process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net'}${service.image_url.startsWith('/') ? service.image_url : `/${service.image_url}`}`)} 
                    alt="Service" 
                    style={{maxWidth: '150px', marginTop: '10px', borderRadius: '4px'}}
                  />
                )}
              </div>
              <div className="editor-item-actions">
                <button className="editor-btn-sm editor-btn-edit" onClick={() => handleEdit(service)}>
                  تعديل
                </button>
                <button 
                  className="editor-btn-sm" 
                  style={{ backgroundColor: '#815327', color: '#fff', margin: '0 5px' }}
                  onClick={() => {
                    setDetailsService(service);
                    setShowDetailsModal(true);
                  }}
                >
                  تفاصيل
                </button>
                <button className="editor-btn-sm editor-btn-delete" onClick={() => handleDelete(service.id)}>
                  حذف
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {showModal && (
        <ServiceModal
          service={editingService}
          onClose={() => {
            setShowModal(false);
            setEditingService(null);
          }}
          onSave={handleSave}
        />
      )}

      {showDetailsModal && detailsService && (
        <ServiceDetailsModal
          service={detailsService}
          onClose={() => {
            setShowDetailsModal(false);
            setDetailsService(null);
          }}
        />
      )}
    </div>
  );
};

export default ServicesEditor;

